import React from 'react';
import HomePage from './HomePage';
import PortfolioPage from './PortfolioPage';
import RankingsPage from './RankingsPage';
import TradesPage from './TradesPage';
import BenchmarkPage from './BenchmarkPage';
import Models from '../Models';
import DemoPage from './DemoPage';
import MissionPage from './MissionPage';
import HowItWorksPage from './HowItWorksPage';
import OpenSourcePage from './OpenSourcePage';
import BacktestResultsPage from './BacktestResultsPage';

import { useLocation } from 'react-router-dom';

const PageRouter = ({ 
  holdings, 
  rankings, 
  trades, 
  portfolioPercentage, 
  ndaqPercentage, 
  spyPercentage, 
  arkkPercentage,
  currentLanguage,
  forceRenderKey,
  toggleBookDemo,
  ticker,
  setTicker,
  loading,
  tickerError,
  tickerResult,
  handleSubmit,
}) => {
  const location = useLocation();
  // Handle HashRouter - remove # and leading slash
  let path = location.pathname;
  if (location.hash) {
    path = location.hash.substring(1); // Remove the #
  }
  const currentTab = path.substring(1) || 'home';

  switch (currentTab) {
    case 'home':
      return <HomePage toggleBookDemo={toggleBookDemo} />;

    case 'how-it-works':
      return <HowItWorksPage />;

    case 'portfolio':
      return <PortfolioPage holdings={holdings} currentLanguage={currentLanguage} />;

    case 'rankings':
      return <RankingsPage rankings={rankings} currentLanguage={currentLanguage} />;

    case 'trades':
      return <TradesPage trades={trades} />;

    case 'benchmark':
      return (
        <BenchmarkPage 
          portfolioPercentage={portfolioPercentage}
          ndaqPercentage={ndaqPercentage}
          spyPercentage={spyPercentage}
          arkkPercentage={arkkPercentage}
        />
      );

    case 'demo':
      return (
        <DemoPage
          forceRenderKey={forceRenderKey}
          ticker={ticker}
          setTicker={setTicker}
          loading={loading}
          tickerError={tickerError}
          tickerResult={tickerResult}
          handleSubmit={handleSubmit}
        />
      );

    case 'mission':
      return <MissionPage />;

    case 'our-models':
      return <Models />;

    case 'open-source':
      return <OpenSourcePage />;

    case 'hyper-v3-results':
    case 'prag-v3-results':
    case 'hyper-v4-results':
    case 'prag-v4-results':
      return <BacktestResultsPage currentTab={currentTab} />;

    default:
      return null;
  }
};

export default PageRouter;
